import React  from 'react';

import Industries from '../Industries/industries';

require('./homepage.css');
require('./homepage-button.css');

function Homepage(props) {
        const startSurveyButtonTitile = props.selectedIndustry ? 'Click to start the survey' : 'Select an industry to begin';
        return (
            <div className="homepage">
                <div className="banner">
                    <div className="question">How prepared is your company for its digital transformation?</div>
                    <div className="description">
                        Take this short survey to gauge your business's readiness for digital transformation.
                        Learn your strongest and weakest areas, and what you can do now to deliver results from your digital transformation.
                    </div>
                </div>
                <Industries
                    jsonConfig={props.jsonConfig}
                    selectIndustry={props.selectIndustry}
                    selectedIndustry={props.selectedIndustry}
                 />
                <button
                    disabled={!props.selectedIndustry}
                    title={startSurveyButtonTitile}
                    className="survey-start-button"
                    // onClick={this.props.onComplete}
                    onClick={props.showStatementsPage}>
                        START THE SURVEY
                </button>
            </div>
        );
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage/homepage.js